import { useEffect, useState } from "react"

import If from "@mobi/components/If"
import Text from "@mobi/ds/components/Text"

import LogoItau from "@mobi/ds/static/icons/filled/logo-itau.svg"

import "./Loader.scss"

const Loader = ({
    ariaBusy = "true",
    isVisible = true,
    loadingText = "Carregando...",
    finishedLoadingText = "Carregamento finalizado."    
}) => {

  const [fistRender, setFistRender] = useState(true)

  useEffect(() => {
    isVisible && setFistRender(false)
    if (!isVisible && !fistRender) {
      setTimeout(() => {
        setFistRender(true)
      }, 1000)
    }
  },[isVisible])

  return (    
    <If
      condition={isVisible}
      renderIf={
        <div
          className="ds-loader"
          aria-busy={ariaBusy}
          aria-live="assertive"
          role="alert"          
        >
          <Text
            as="p"
            className="ds-loader__text"
            >
              {loadingText}
          </Text>
          <figure className={"ds-loader__logo"}>
            <LogoItau width={40} height={40} />
          </figure>
          <div className="ds-loader__spinner" />
        </div>
      }
      renderElse={
        <If
          condition={!fistRender}          
          renderIf={
            <div aria-live="assertive" role="alert" aria-busy={ariaBusy}>
              <Text
                as="p"
                className="ds-loader__text"
              >
                {finishedLoadingText}
              </Text>
            </div>
          }
        />
      }   
    />       
  )
}

export default Loader
